module.exports = "/_next/static/images/teamDescriptionPhoto-71dbdc121ea473c787623c8cbc186478.webp";